import { useEffect, useCallback } from 'react';

declare global {
  interface Navigator {
    setAppBadge?: (contents?: number) => Promise<void>;
    clearAppBadge?: () => Promise<void>;
  }
}

// Hook personalizado para gerenciar badges

export const useBadging = (): any => {
  // Verifica se a Badging API está disponível
  const isBadgingSupported = useCallback(() => {
    return (
      'setAppBadge' in navigator && typeof navigator.setAppBadge === 'function'
    );
  }, []);

  // Remove o badge
  const clearBadge = useCallback(() => {
    if (!isBadgingSupported() || !navigator.clearAppBadge) {
      return;
    }

    navigator.clearAppBadge().catch((err: any) => {
      console.error('Erro ao limpar badge:', err);
    });
  }, []);

  // Define o badge com um número
  const setBadge = useCallback((count: number) => {
    if (!isBadgingSupported() || !navigator.setAppBadge) {
      console.warn('Badging API não é suportada neste navegador');
      return;
    }

    if (count > 0) {
      navigator.setAppBadge(count).catch((err: any) => {
        console.error('Erro ao definir badge:', err);
      });
    } else {
      // Remove o badge se count for 0
      clearBadge();
    }
  }, []);

  return {
    setBadge,
    clearBadge,
    isBadgingSupported,
  };
};
